import styled from "styled-components";

export const RootContainer = styled.div`
	padding: 20px 16px;
	background: #F4F4F4;
	.infinite-scroll-component__outerdiv {
		height: calc(100vh - 110px);
	}

	.infinite-scroll-component {
		height: 100% !important;
		overflow-x: hidden !important;
	}

	@media screen and (max-width: 361px) {
		padding: 16px 12px;
	}
`;

export const HistoryBox = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px ;
	gap: 8px;
	border-radius: 4px;
	background: #FFF;
	margin-bottom: 8px;

	@media screen and (max-width: 361px) {
		padding: 8px 6px;
	}
`;

export const DateAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
export const Date = styled.p`
	flex-grow: 1;

	color: #2A2A2A;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */
`;
export const Amount = styled.p`
	color: #2A2A2A;
	font-size: 17px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */
`;

export const ExpireBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	gap: 4px;
`;

export const ExpireText = styled.p`
	color: #BF3837;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
`;

export const ExpiredTime = styled.p`
	color: #5C5C5C;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${(props) =>
		props.size === "large" ? "calc(100vh - 110px)" : "auto"};
`;

export const EmptyText = styled.div`
	height: calc(100vh - 110px);
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	gap: 16px;

	color: #2A2A2A;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 28px; /* 155.556% */

	svg{
		width: 120px;
		height: 120px;
	}
`;

export const HistoryWrapper = styled.div`
	max-height: 700px;
`;


export const Title = styled.p`
	color: #2A2A2A;
	text-align: left;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */

	margin-bottom: 16px;
`